<template>
  <span class="glyph" :style="{ '--glyph-size': size, '--glyph-accent': accent }">
    <img v-if="src && !broken" :src="src" :alt="label" loading="lazy" @error="broken = true" />
    <span v-else class="glyph__fallback">{{ initial }}</span>
  </span>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
  src: { type: String, default: null },
  label: { type: String, default: '' },
  size: { type: String, default: '1.75rem' },
  accent: { type: String, default: 'var(--gm-accent)' },
});

// Emblems are uploads, so a row can point at a file that is no longer on disk.
// The initial keeps the row the same shape instead of collapsing it.
const broken = ref(false);
watch(() => props.src, () => { broken.value = false; });

const initial = computed(() => (props.label || '?').trim().charAt(0).toUpperCase());
</script>

<style scoped>
.glyph {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--glyph-size);
  height: var(--glyph-size);
  border-radius: var(--gm-radius-sm);
  overflow: hidden;
  background: var(--gm-surface-sunken);
  border: 1px solid var(--gm-border-dim);
}

.glyph img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.glyph__fallback {
  font-family: var(--gm-font-display);
  font-size: calc(var(--glyph-size) * 0.45);
  font-weight: 700;
  color: var(--glyph-accent);
}
</style>
